import { render, staticRenderFns } from "./PaginationPanelOrder.vue?vue&type=template&id=6c369ff9&scoped=true"
import script from "./PaginationPanelOrder.vue?vue&type=script&lang=ts"
export * from "./PaginationPanelOrder.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPanelOrder.vue?vue&type=style&index=0&id=6c369ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c369ff9",
  null
  
)

export default component.exports